import _createClass from '@babel/runtime/helpers/esm/createClass';

/* eslint-disable */
var ExpressionQuery = /*#__PURE__*/function () {
  function ExpressionQuery(expressionQuery) {
    if (expressionQuery) {
      this._type = expressionQuery.type;
      this._key = expressionQuery.key;
      this._value = expressionQuery.value;
      this._isExact = expressionQuery.isExact;
    }
  }

  var _proto = ExpressionQuery.prototype;

  _proto.getExpressionQueryObjectification = function getExpressionQueryObjectification() {
    return {
      type: this._type,
      key: this._key,
      value: this._value,
      isExact: this._isExact
    };
  };

  _createClass(ExpressionQuery, [{
    key: 'type',
    get: function get() {
      return this._type;
    }
  }, {
    key: 'key',
    get: function get() {
      return this._key;
    }
  }, {
    key: 'value',
    get: function get() {
      return this._value;
    }
  }, {
    key: 'isExact',
    get: function get() {
      return this._isExact;
    }
  }]);

  return ExpressionQuery;
}();

export { ExpressionQuery as default };